import { openreplaySetMetadata } from 'utils/openreplay'

const STORAGE_KEY = 'orVenueMetaSent'

/**
 * 每个会话、每个 venue 只给 OpenReplay 打一次 venue/venueName metadata。
 * 用 sessionStorage 去重,避免每次进页面/拿 venue 信息都重复发,浪费上报数据。
 * @param {String} venue venue 标识(url slug)
 * @param {String} [venueName] 餐厅全名
 */
function setVenueMetaOnce(venue, venueName) {
  if (!venue) return
  if (sessionStorage.getItem(STORAGE_KEY) === venue) return
  sessionStorage.setItem(STORAGE_KEY, venue)
  openreplaySetMetadata('venue', venue)
  if (venueName) openreplaySetMetadata('venueName', venueName)
}

export { setVenueMetaOnce }
